import React from 'react';
import { IconButton } from '@paypalcorp/pp-react';
import { closeWindow, isInContext } from '../utility/inContextDonation';
import TemplateData from '../utility/getTemplateData';

export default function CloseButton() {
  const handleClose = () => {
    if (isInContext()) {
      closeWindow();
      return;
    }
    window.location.href = TemplateData.charityCancelUrl;
  };
  return (
    <IconButton
      data-testid="close-button"
      iconName="close"
      onClick={handleClose}
      className="close-button"
    />
  );
}
